import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getPathNoLangOnClient } from '@/utils/url';
import { updateSessionTokenMaxAge } from '@/utils/common/session';
import { getCookie, setCookie } from '@/utils/cookie';
import Constants from '@/constants/const';
import { getTrackSession } from '@/api/tracking';
import useAccount from '@/store/account';
import { isRobot } from '@/utils/common/device';

export const checkSeesion = async () => {
  const sessionToken = getCookie(Constants.WEEE_SESSION_TOKEN) || '';
  const bCookie = getCookie(Constants.B_COOKIE) || '';
  const url = encodeURIComponent(getPathNoLangOnClient(window.location.pathname + window.location.search));
  // 爬虫不检查session token
  if (isRobot()) {
    return;
  }
  if (!+sessionToken) {
    return getTrackSession('normal', url).then(({ object }) => {
      setCookie(
        Constants.WEEE_SESSION_TOKEN,
        object?.weee_session_token,
        {},
        {
          maxAge: Constants.WEEE_SESSION_TOKEN_MAX_AGE
        }
      );
      if (!+bCookie) {
        setCookie(
          Constants.B_COOKIE,
          object?.weee_session_token,
          {},
          {
            maxAge: Constants.WEEE_SESSION_TOKEN_MAX_AGE
          }
        );
      }
    });
  }
  if (!+bCookie) {
    setCookie(
      Constants.B_COOKIE,
      sessionToken,
      {},
      {
        maxAge: Constants.WEEE_SESSION_TOKEN_MAX_AGE
      }
    );
  }

  updateSessionTokenMaxAge();
};

export default function useCheckSession() {
  const router = useRouter();
  const { userPreOrderLogged } = useAccount();

  useEffect(() => {
    if (!userPreOrderLogged) {
      return;
    }
    const handleRouteChangeStart = () => {
      setTimeout(() => {
        checkSeesion();
      });
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, [userPreOrderLogged]);

  useEffect(() => {
    let hiddenProperty =
      'hidden' in document
        ? 'hidden'
        : 'webkitHidden' in document
        ? 'webkitHidden'
        : 'mozHidden' in document
        ? 'mozHidden'
        : null;
    let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
    let onVisibilityChange = () => {
      if (!!document[hiddenProperty]) {
        checkSeesion();
      }
    };
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);
    return () => {
      document.removeEventListener(visibilityChangeEvent, onVisibilityChange);
    };
  }, []);

  return;
}
